import React from "react";

function PlantelesPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) {
        return null;
    }

    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

    // On small screens, show a window of pages around the current one
    const getVisiblePages = () => {
        if (totalPages <= 5) return pages;
        const start = Math.max(1, currentPage - 1);
        const end = Math.min(totalPages, currentPage + 1);
        const visible = [];
        if (start > 1) {
            visible.push(1);
            if (start > 2) visible.push("...");
        }
        for (let i = start; i <= end; i++) visible.push(i);
        if (end < totalPages) {
            if (end < totalPages - 1) visible.push("...");
            visible.push(totalPages);
        }
        return visible;
    };

    const visiblePages = getVisiblePages();

    return (
        <div className="mt-6 sm:mt-10 space-y-2 sm:space-y-3">
            <p className="text-center text-xs sm:text-sm text-slate-400 font-medium">
                Página {currentPage} de {totalPages}
            </p>

            <div className="overflow-x-auto scrollbar-hide">
                <div className="flex items-center justify-center gap-1 min-w-max px-1">
                    <button
                        type="button"
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="h-9 px-2.5 sm:px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500 transition-colors"
                    >
                        ←
                    </button>

                    {visiblePages.map((page, index) =>
                        page === "..." ? (
                            <span key={`ellipsis-${index}`} className="h-9 min-w-7 flex items-center justify-center text-slate-500 text-sm">
                                ...
                            </span>
                        ) : (
                            <button
                                key={page}
                                type="button"
                                onClick={() => onPageChange(page)}
                                className={`h-9 min-w-[2rem] sm:min-w-9 px-2 sm:px-3 rounded-lg text-xs sm:text-sm font-bold border transition-colors ${currentPage === page
                                    ? "bg-green-500 text-[#062a1a] border-green-500"
                                    : "bg-[#102216] text-slate-200 border-white/10 hover:border-green-500"
                                    }`}
                            >
                                {page}
                            </button>
                        )
                    )}

                    <button
                        type="button"
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="h-9 px-2.5 sm:px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500 transition-colors"
                    >
                        →
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PlantelesPagination;
